export default __webpack_public_path__ + "static/Sir Furqan-7b696242245ac478cde73bfa4d9e5c41.jpg";